/**
 * Created by Vladislav on 03.08.2026.
 */

class ScaleComponent extends BaseComponent {
    onCreate() {
        this.scale = this.options.scale;
        this.mobileScale = this.options.mobileScale;
    }

    // resolved here and not in the constructor - components are created in json key order,
    // so a "#Controller.getScale" scale can name a component that does not exist yet
    onAttach() {
        if (this.context) {
            this.scale = PrefabBuilder.resolveProperty(this.scale, this.context);
            this.mobileScale = PrefabBuilder.resolveProperty(this.mobileScale, this.context);
            delete this.context;
        }

        this.onResize();
    }

    setScale(scale) {
        this.scale = scale;

        this.onResize();
    }

    setMobileScale(mobileScale) {
        this.mobileScale = mobileScale;

        this.onResize();
    }

    onResize() {
        let scale;
        if (connector.info.isMobile && this.mobileScale) {
            scale = this.mobileScale;
        } else {
            scale = this.scale;
        }

        this.node.setScale(Array.isArray(scale) ? scale[cleverapps.resolution.mode] : scale);
        this.node.baseScale = this.node.scale;
    }
}

Prefab.registerComponent("ScaleComponent", {
    scale: {
        type: "number",
        default: 1,
        getter: (component) => component.scale,
        setter: (component, value, context) => component.setScale(PrefabBuilder.resolveProperty(value, context))
    },
    mobileScale: {
        type: "number",
        getter: (component) => component.mobileScale,
        setter: (component, value, context) => component.setMobileScale(PrefabBuilder.resolveProperty(value, context))
    }
}, ScaleComponent);
